module.exports = __webpack_public_path__ + "static/logo-b9d1e600728dea108eff4b2ec2d9d567.png";